import React from "react";
import { codeProjectSave } from "../../actions/project";
import { connect } from "react-redux";
import { faArrowLeft, faBars, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import Alert from "../../components/Alert";

class AdminProjectAdd extends React.Component {
    state = {
        menuActive: false,
        opts: [{
            type: 'link',
            ttl: "Retourner à la liste des projets",
            ico: faArrowLeft,
            link: "/admin/projects",
            action: null,
            col: null
        }],
        form: {
            name: ''
        },
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none"; 
        })
        document.getElementById('page').classList.add('pageWithout');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.redCdPrSave != this.props.redCdPrSave) {
            this.setState({
                alert: this.props.redCdPrSave.alert
            })
        }
    }

    handleSubmit = (el) => {
        el.preventDefault();
        this.props.codeProjectSave({
            idProject: null,
            name: this.state.form.name
        });
        this.setState({
            alert: tempAlWait()
        })
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut
                ttl="Code - Créer un projet"
                options={this.state.opts}
            />

            {/** Données de la page **/}
            <div className="admin__ctnr">
                {/** Formulaire **/}
                <form className="admin__form">
                    {/** Nom du projet **/}
                    <div className="admin__inpgrp" title="Nom du projet" aria-label="Nom du projet">
                        <label className="admin__lab" label="pr-name">Nom *</label>
                        <input
                            required
                            type="text"
                            placeholder="Nom du projet"
                            className="admin__input"
                            id="pr-name"
                            value={this.state.form.name}
                            onChange={(el) => {
                                this.setState(prevState => ({
                                    form: {
                                        ...prevState.form,
                                        name: el.target.value
                                    }
                                }))
                            }}
                        />
                    </div>

                    {/** Bouton enregistré **/}
                    <button
                        title="Enregistrer le projet"
                        aria-label="Enregistrer le projet"
                        className="admin__btnsave"
                        type="button"
                        onClick={(el) => this.handleSubmit(el)}
                    >
                        <FontAwesomeIcon icon={faFloppyDisk} />
                        <span className="admin__btnsavetxt">Enregistrer</span>
                    </button>
                </form>
            </div>
            <Alert alert={this.state.alert} />
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redCdPrSave: state.redCdPrSave
    }
}

const mapDispatchToProps = {
    codeProjectSave
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminProjectAdd);